import DesktopDatePicker from './DesktopDatePicker';

export default DesktopDatePicker;



// WEBPACK FOOTER //
// ./src/components/atoms/DesktopDatePicker/index.js